export const modalModes = {
  view: "view",
  edit: "edit",
  create: "create"
};
